import React, { useState, useEffect } from 'react';
import { Button, Modal, Container, Pagination, Table, Spinner, Row, Col } from "react-bootstrap";
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';
import { ViewManager } from '../../../core/view-manager';
import FieldPreviewSimple from '../../../components/Entity/FieldPreviewSimple';
import { Utils } from '../../../core/utils';
import _ from "lodash";
import SearchPro from '../../../components/Entity/SearchPro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { settings } from '../../../config/settings';


export default function ModalListPicker({ entity = null, defaultSearchObj = null, modalStatus, closeModal, selectRow, defaultSorting }) {

    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [data, setData] = useState(null);
    const [limit, setLimit] = useState( (settings.configEntity && settings.configEntity[entity]) ? settings.configEntity[entity].limit : 30 );
    const fields = Utils.cloneObject(ViewManager.getVisibleColumns(entity));
    const properties = Utils.cloneObject(ViewManager.getEntityProperties(entity));
    const searchableFields = Utils.cloneObject(ViewManager.getSearchableColumns(entity));
    const [searchObj, setSearchObj] = useState(defaultSearchObj ? defaultSearchObj : {
        'query': '',
        'fields': searchableFields,
        'constraints': []
    });
    const [sorting, setSorting] = useState(defaultSorting ? defaultSorting : { "field": 'id', "order": "desc" });


    useEffect(() => {
        if (entity !== null && modalStatus === true) {
            getData(page, limit)
        }
    }, [page, limit, entity, searchObj, modalStatus, sorting]);


    async function getData(page, limit) {
        setLoading(true)

        if (searchObj === null) {
            var response = await DataManager.getItemsSimple(entity, page, limit, sorting)
        }
        else {
            let query = searchObj.query || ''
            let fields = searchObj.fields || []
            let constraints = searchObj.constraints || []
            var response = await DataManager.searchItemsSimple(entity, page, limit, sorting, query, fields, constraints)
        }
        if (response.success === 1) {
            setData(response.body);
            setTotalPages(response.pages)
            setTotal(response.total)
        }
        else {
            console.warn(response)
        }
        setLoading(false)
    }

    /* paginations */
    function goToPrevPage() {
        if (page > 1) {
            setPage(page - 1)
        }
    }
    function goToNextPage() {
        if (page < totalPages) {
            setPage(page + 1)
        }
    }
    function goToFirstPage() {
        if (page !== 1) {
            setPage(1)
        }
    }
    function goToLastPage() {
        if (page !== totalPages) {
            setPage(totalPages)
        }
    }


    function close() {
        setData(null)
        setPage(1)
        closeModal()
    }

    function selectItem(item) {
        selectRow(item)
    }


    function search(obj) {
        if (_.isEqual(obj, searchObj)) {
            // oggetti uguali non triggero la ricerca
        }
        else {
            setPage(1)
            setSearchObj(obj)
        }
    }

    function orderBy(field) {
        var excluded = ['richText', 'file', 'externalEntity', 'multipleExternalEntity', 'deepExternalEntity']
        var type = properties.columns[field].input_type
        if (!excluded.includes(type)) {
            var s = { ...sorting }
            var order = s.order === 'desc' ? 'asc' : 'desc';
            setSorting({ "field": field, "order": order })
        }
    }


    if (modalStatus) {
        return (
            <>
                <Modal tabIndex={1} show={modalStatus} onHide={closeModal} size={settings.modalDefaultSize && settings.modalDefaultSize.listPicker ? settings.modalDefaultSize.listPicker : "xl"} fullscreen={settings.modalFullscreen && settings.modalFullscreen.listPicker ? settings.modalFullscreen.listPicker : false} scrollable={true} backdrop="static" backdropClassName='backdropped'>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {LanguageProvider.get('entity.' + entity)}
                            {loading === true ? (
                                <span>
                                    <Spinner className='ms-3' size='md' animation="border" variant="secondary" />
                                </span>
                            ) : (
                                <span>&nbsp;</span>
                            )}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ height: '1200px' }}>

                        {(entity !== null && data !== null && fields !== null && properties !== null) ? (
                            <>
                                <SearchPro entity={entity} setSearchObj={search} searchObj={defaultSearchObj} loading={loading} />

                                <div className='data-grid-container'>
                                    <Table striped hover responsive className='small mt-3 datagrid-table' data-entity-name={entity}>
                                        <thead className='small'>
                                            <tr>
                                                {fields.map((label, j) => {
                                                    var chevron = sorting.order === 'desc' ? 'chevron-down' : 'chevron-up';
                                                    return (
                                                        <th key={j} onClick={() => orderBy(label)} data-column-name={label}>
                                                            {LanguageProvider.getLabel(entity, label)}
                                                            {sorting.field === label ? (
                                                                <>
                                                                    <FontAwesomeIcon icon={chevron} size={'xs'} color='#000' className='ms-2' />
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </th>
                                                    )
                                                })}
                                                <th className='head-last-td' colSpan={2}></th>
                                            </tr>
                                        </thead>
                                        <tbody className='small'>
                                            {data.map((item, i) => {
                                                return (
                                                    <tr key={i} data-id={item.id}>
                                                        {fields.map((label, j) => {
                                                            return (
                                                                <td key={j}>
                                                                    <FieldPreviewSimple item={item} field={label} props={properties} entity={entity} />
                                                                </td>
                                                            )
                                                        })}
                                                        <td className='text-end last-td' colSpan={2}>
                                                            <Button size='sm' onClick={() => selectItem(item)}>{LanguageProvider.get('defaults.select')} <FontAwesomeIcon icon="check" className='ms-1' /></Button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </>
                        ) : (
                            <Spinner />
                        )}

                    </Modal.Body>
                    <Modal.Footer style={{ display: 'block' }}>
                        <Row>
                            <Col xs={12} md={6} className='my-1'>
                                <Pagination className='m-0'>
                                    <Pagination.First className={page === 1 ? 'disabled' : ''} onClick={goToFirstPage} />
                                    <Pagination.Prev className={page <= 1 ? 'disabled' : ''} onClick={goToPrevPage} />
                                    <Pagination.Item key={page}>
                                        {page}
                                    </Pagination.Item>
                                    <Pagination.Next className={page >= totalPages ? 'disabled' : ''} onClick={goToNextPage} />
                                    <Pagination.Last className={page >= totalPages ? 'disabled' : ''} onClick={goToLastPage} />
                                </Pagination>
                            </Col>
                            <Col xs={12} md={6} className='text-end my-1'>
                                <Button variant="secondary" onClick={close} className='mx-1'>
                                    {LanguageProvider.get('defaults.close')}
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
};